import { NotificationsOutlinedIcon } from 'common/icons';
import { NeutralColors } from 'theme';

import { NotificationWebItem } from '../../notifications.model';
import {
  formatNotificationTime,
  getNotificationDescription,
  getNotificationTitle,
} from '../../notifications.util';
import * as Styled from './notification-item.style';

interface NotificationItemProps {
  item: NotificationWebItem;
  onClick: (item: NotificationWebItem) => void;
}

const NotificationItem = ({ item, onClick }: NotificationItemProps) => {
  const title = getNotificationTitle(item);
  const description = getNotificationDescription(item);
  const time = formatNotificationTime(item.createdAt);

  return (
    <Styled.NotificationItemWrapper
      isUnread={!item.read}
      onClick={() => onClick(item)}
    >
      <Styled.NotificationIcon>
        <NotificationsOutlinedIcon
          style={{ width: 24, height: 24, fill: NeutralColors[60] }}
        />
      </Styled.NotificationIcon>
      <Styled.NotificationBody>
        <Styled.NotificationTitle>{title}</Styled.NotificationTitle>
        {description && (
          <Styled.NotificationDescription>
            {description}
          </Styled.NotificationDescription>
        )}
        <Styled.NotificationTime>{time}</Styled.NotificationTime>
      </Styled.NotificationBody>
      {!item.read && <Styled.UnreadDot />}
    </Styled.NotificationItemWrapper>
  );
};

export { NotificationItem };
